/**
 * Проверка браузера Safari
 * @category Utils
 */
export function isSafariBrowser() {
    // Для серверного рендеринга всегда возвращаем false
    if (typeof window !== 'object') {
        return false;
    }

    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome');
}

/**
 * Проверка устройства IOS
 * @category Utils
 */
export function isIOSDevice() {
    // Для серверного рендеринга всегда возвращаем false
    if (typeof window !== 'object') {
        return false;
    }

    const ua = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(ua);
};